import axios from 'axios';
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';
import { setDropDownStyle } from '../CommonHelper';
import TinyEditor from '../Common-Components/TinyEditor';

const UGC_ArticlesModal = forwardRef((props, ref) => {
    const [modalBox, setModalBox] = useState(false);
    let initialData = {
        Title: '',
        Description: '',
        Type: 'Articles',
        Source: 'Ugc',
        Status: 1,
        DisplayOrder: 0
    }

    const [articleData, setArticleData] = useState(initialData);
    const [articleTypesList, setArticleTypesList] = useState([]);

    React.useEffect(() => {
        axios.get(BACKEND_SERVER_URL + '/getArticleTypes').then((res) => {
            if (res.data && res.data.data) {
                setArticleTypesList(res.data.data.filter(t => t.Status === 1));
            }
        }).catch((error) => console.log(error));
    }, []);

    useImperativeHandle(ref, () => ({
        openModal(item = {}) {
            if (item.Sn > 0) {
                setArticleData({
                    Title: item.Title,
                    Description: item.Description,
                    Type: item.Type,
                    Source: item.Source,
                    Status: item.Status,
                    DisplayOrder: item.DisplayOrder || 0,
                    Sn: item.Sn
                })
            } else {
                setArticleData(initialData);
            }
            setModalBox(true);
        }
    }));

    const handleChange = (name, value) => {
        setArticleData({ ...articleData, [name]: value });
    }

    const handleSaveArticle = async () => {
        try {
            if (articleData.Title.trim().length === 0) {
                toast.error("Please enter title")
                return;
            } else if (articleData.Description.trim().length === 0) {
                toast.error("Please enter description")
                return;
            }

            const endpoint = !articleData.Sn ? '/ugc/createArticle' : `/ugc/updateArticle/${articleData.Sn}`;
            const response = await axios.post(BACKEND_SERVER_URL + endpoint, articleData);

            toast.success(response.data.message);
            props.setArticleLoading(!props.loadArticles);
            setModalBox(false);
        } catch (error) {
            console.log(error)
            toast.error(error?.response?.data?.message || "Error saving article")
        }
    }

    return (
        <Modal onHide={() => setModalBox(false)} show={modalBox} size="lg" backdrop="static" keyboard={false}>
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title"> {articleData.Sn ? "Update Article" : "Add Article"}</h5>
                    <button type="button" className="btn-close" onClick={() => setModalBox(false)}></button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-xl-8 mb-3">
                            <label className="form-label text-primary">Title<span className="required">*</span></label>
                            <input autoFocus className='form-control' type="text" value={articleData.Title} onChange={(e) => setArticleData({ ...articleData, Title: e.target.value })} />
                        </div>
                        <div className="col-xl-4 mb-3">
                            <label className="form-label text-primary">Display Order</label>
                            <input className='form-control' type="number" value={articleData.DisplayOrder} onChange={(e) => setArticleData({ ...articleData, DisplayOrder: e.target.value })} />
                        </div>
                        <div className="col-xl-6 mb-3">
                            <label className="form-label text-primary">Type<span className="required">*</span></label>
                            <Select
                                value={{ value: articleData.Type, label: articleData.Type }}
                                onChange={(selectedOption) => setArticleData({ ...articleData, Type: selectedOption.value })}
                                options={articleTypesList.map((typeObj) => ({ value: typeObj.Type, label: typeObj.Type }))}
                                styles={setDropDownStyle()}
                            />
                        </div>
                        <div className="col-xl-6 mb-3">
                            <label className="form-label text-primary">Status<span className="required">*</span></label>
                            <Select
                                value={{ value: articleData.Status, label: articleData.Status == 1 ? "Active" : "Inactive" }}
                                onChange={(selectedOption) => setArticleData({ ...articleData, Status: selectedOption.value })}
                                options={[
                                    { value: 1, label: "Active" },
                                    { value: 0, label: "Inactive" }
                                ]}
                                styles={setDropDownStyle()}
                            />
                        </div>
                        <div className="col-xl-12 mb-3">
                            <TinyEditor labelName="Description" inputValue={articleData.Description} inputName="Description" handleChangeCallBack={handleChange} isMandatory={true} />
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-danger btn-xs" onClick={() => setModalBox(false)}>Close</button>
                    <button type="button" className="btn btn-primary btn-xs " onClick={handleSaveArticle}>{articleData.Sn ? "Update" : "Save"}</button>
                </div>
            </div>
        </Modal>
    )
})

export default UGC_ArticlesModal;
